import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c14a06f&scoped=true"
import script from "./index.vue?vue&type=script&scoped=true&lang=js"
export * from "./index.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c14a06f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c14a06f",
  null
  
)

export default component.exports